const initialState = {
  loading: false,
  errors: {},
  customer_name: '',
  phone_number: '',
  purchase_orders: [],
  store_number: '',
};

const refigureForm = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'REQUEST_REFIGURE_FORM_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'REQUEST_REFIGURE_FORM_SUCCESS':
      return Object.assign({}, state, payload.refigure, { loading: false });
    case 'REQUEST_REFIGURE_FORM_FAILURE':
      return {
        ...state,
        loading: false,
        errors: payload.errors,
      };
    case 'SUBMIT_REFIGURE_FORM_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'SUBMIT_REFIGURE_FORM_SUCCESS':
      return {
        ...state,
        loading: false,
      };
    case 'SUBMIT_REFIGURE_FORM_FAILURE':
      return {
        ...state,
        loading: false,
        errors: payload.errors,
      };
    default:
      return state;
  }
};

export default refigureForm;



// WEBPACK FOOTER //
// ./client/app/reducers/refigure_form.js